export default __webpack_public_path__ + "static/soehne-mono-web-leicht-765e3bf101729f2df71a64bb8521220c.woff";